// store/slices/adminSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDashboard,
  fetchCoupons,
  fetchUsers,
  fetchWalletUsers,
  fetchCreditUsers,
  fetchSKU,
  updateSKU,
  fetchBrands,
  updateBrand,
  addWalletBalance,
  fetchOrderDetails,
  fetchUserDetail,
  updateCouponStatusById,
  fetchProductDetails,
  addBulkOrderUser,
  updateOrderStatus,
  fetchSubCategory,
  addProduct,
  toggleCreditStatus,
  activateCredit,
  checkPhoneNumber,
  registerPhoneNumber,
  fetchUsersCart,
  fetchCartDetails,
  addCoupon,
  updateInvoice,
  fetchWalletDetail,
  updateWalletBalance,
} from "../api/api";
import { InitialState } from "@/types/user";
import {
  AddBulkOrderUser,
  AddProduct,
  AddWalletBalance,
  CouponData,
  CreditActivationData,
  UpdateBrand,
  UpdateInvoiceProps,
  UpdateOrderStatus,
  UpdateSKU,
  UpdateWalletBalance,
} from "@/types/api";

const initialState: InitialState = {
  dashboard: null,
  orderDetail: null,
  coupons: [],
  users: null,
  usersCart:[],
  userDetail: null,
  cartDetail:null,
  walletUsers: [],
  creditUsers: [],
  sku: [],
  subCategories: [],
  productDetail: null,
  brands: [],
  walletDetail: null,
  dashboardLoading: false,
  couponLoading: false,
  userLoading: false,
  walletLoading: false,
  creditLoading: false,
  skuLoading: false,
  brandLoading: false,
  userDetailLoading: false,
  orderDetailLoading: false,
  productDetailLoading: false,
  subCategoriesLoading: false,
  addProductLoading: false,
  creditStatusLoading: false,
  checkPhoneNumberLoading:false,
  registerPhoneNumberLoading:false,
  usersCartLoading:false,
  cartDetailLoading:false,
  addCouponLoading:false,
  walletDetailLoading:false,
  error: null as string | null,
};

// Thunks
export const getDashboard = createAsyncThunk("admin/dashboard", async () => {
  const response = await fetchDashboard();
  return response;
});

export const getCoupons = createAsyncThunk("admin/coupons", async () => {
  const response = await fetchCoupons();
  return response;
});

export const updateCouponById = createAsyncThunk(
  "admin/updateCouponStatusById",
  async (couponId: number) => {
    const response = await updateCouponStatusById(couponId);
    return response;
  }
);

export const getUsers = createAsyncThunk("admin/users", async () => {
  const response = await fetchUsers();
  return response;
});

export const updateCreditStatus = createAsyncThunk(
  "admin/toggleCreditStatus",
  async (userID: number) => {
    const response = await toggleCreditStatus(userID);
    return response;
  }
);

export const getSubCategories = createAsyncThunk(
  "admin/subcategories",
  async () => {
    const response = await fetchSubCategory();
    return response;
  }
);

export const getWalletUsers = createAsyncThunk(
  "admin/walletUsers",
  async () => {
    const response = await fetchWalletUsers();
    return response;
  }
);
export const getUsersCart = createAsyncThunk(
  "admin/fetchUsersCart",
  async () => {
    const response = await fetchUsersCart();
    return response;
  }
);

export const getCreditUsers = createAsyncThunk(
  "admin/creditUsers",
  async () => {
    const response = await fetchCreditUsers();
    return response;
  }
);

export const getSKU = createAsyncThunk("admin/sku", async () => {
  const response = await fetchSKU();
  return response;
});

export const postSKU = createAsyncThunk(
  "admin/updateSKU",
  async (data: UpdateSKU) => {
    console.log(data);
    const response = await updateSKU(data);
    return response;
  }
);

export const activateUserCredit = createAsyncThunk(
  "admin/activateUserCredit",
  async (data: CreditActivationData) => {
    const response = await activateCredit(data);
    return response;
  }
);

export const getBrands = createAsyncThunk("admin/brands", async () => {
  const response = await fetchBrands();
  return response;
});

export const getOrderDetails = createAsyncThunk(
  "admin/fetchOrderDetails",
  async (orderNumber: string) => {
    const response = await fetchOrderDetails(orderNumber);
    return response;
  }
);

export const getCartDetails = createAsyncThunk(
  "admin/fetchCartDetails",
  async (phoneNumber: string) => {
    const response = await fetchCartDetails(phoneNumber);
    return response;
  }
);

export const getProductDetails = createAsyncThunk(
  "admin/fetchPrductDetails",
  async (prod_ID: string) => {
    const response = await fetchProductDetails(prod_ID);
    return response;
  }
);

export const postBrand = createAsyncThunk(
  "admin/updateBrand",
  async (data: UpdateBrand) => {
    const response = await updateBrand(data);
    return response.data;
  }
);

export const postWalletBalance = createAsyncThunk(
  "admin/addWalletBalance",
  async (data: AddWalletBalance) => {
    const response = await addWalletBalance(data);
    return response.data;
  }
);
export const postUpdateWalletBalance = createAsyncThunk(
  "admin/updateWalletBalance",
  async (data: UpdateWalletBalance) => {
    const response = await updateWalletBalance(data);
    return response.data;
  }
);
export const fetchWalletDetailAsync = createAsyncThunk(
  "admin/fetchWalletDetail",
  async (userID: number) => {
    const response = await fetchWalletDetail(userID);
    return response;
  }
);

export const addCouponCode = createAsyncThunk(
  "admin/addCoupon",
  async (data: CouponData) => {
    const response = await addCoupon(data);
    return response.data;
  }
);

export const postAddBulkOrderUser = createAsyncThunk(
  "admin/addBulkOrderUser",
  async (data: AddBulkOrderUser) => {
    const response = await addBulkOrderUser(data);
    return response.data;
  }
);

export const postUpdateOrderStatus = createAsyncThunk(
  "admin/updateOrderStatus",
  async (data: UpdateOrderStatus) => {
    const response = await updateOrderStatus(data);
    return response.data;
  }
);

export const postUpdateInvoice = createAsyncThunk(
  "admin/updateInvoice",
  async (data: UpdateInvoiceProps) => {
    const response = await updateInvoice(data);
    console.log(response)
    return response.data;
  }
);

export const postAddProduct = createAsyncThunk(
  "admin/addProduct",
  async (data: AddProduct) => {
    const response = await addProduct(data);
    return response.data;
  }
);

export const getUserDetail = createAsyncThunk(
  "admin/fetchUserDetail",
  async (userID: number) => {
    const response = await fetchUserDetail(userID);
    return response;
  }
);

export const checkPhoneNumberAsync = createAsyncThunk(
  "admin/checkPhoneNumber",
  async (phoneNumber: string) => {
    const response = await checkPhoneNumber(phoneNumber);
    return response;
  }
);

export const registerPhoneNumberAsync = createAsyncThunk(
  "admin/registerPhoneNumber",
  async (phoneNumber: string) => {
    const response = await registerPhoneNumber(phoneNumber);
    return response;
  }
);

// Slice
const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboard.pending, (state) => {
        state.dashboardLoading = true;
      })
      .addCase(getDashboard.fulfilled, (state, action) => {
        state.dashboard = action.payload;
        state.dashboardLoading = false;
      })
      .addCase(getOrderDetails.pending, (state) => {
        state.orderDetailLoading = true;
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.orderDetail = action.payload;
        state.orderDetailLoading = false;
      })
      .addCase(getCoupons.pending, (state) => {
        state.couponLoading = true;
      })
      .addCase(getCoupons.fulfilled, (state, action) => {
        state.coupons = action.payload;
        state.couponLoading = false;
      })
      .addCase(getUsers.pending, (state) => {
        state.userLoading = true;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload;
        state.userLoading = false;
      })
      .addCase(postAddProduct.pending, (state) => {
        state.addProductLoading = true;
      })
      .addCase(postAddProduct.fulfilled, (state) => {
        state.addProductLoading = false;
      })
      .addCase(getSubCategories.pending, (state) => {
        state.subCategoriesLoading = true;
      })
      .addCase(getSubCategories.fulfilled, (state, action) => {
        state.subCategories = action.payload;
        state.subCategoriesLoading = false;
      })
      .addCase(getUserDetail.pending, (state) => {
        state.userDetailLoading = true;
      })
      .addCase(getUserDetail.fulfilled, (state, action) => {
        state.userDetail = action?.payload[0];
        state.userDetailLoading = false;
      })
      .addCase(getCartDetails.pending, (state) => {
        state.cartDetailLoading = true;
      })
      .addCase(getCartDetails.fulfilled, (state, action) => {
        state.cartDetail = action?.payload;
        state.cartDetailLoading = false;
      })
      .addCase(getWalletUsers.pending, (state) => {
        state.walletLoading = true;
      })
      .addCase(getWalletUsers.fulfilled, (state, action) => {
        state.walletUsers = action.payload?.data;
        state.walletLoading = false;
      })
      .addCase(getCreditUsers.pending, (state) => {
        state.creditLoading = true;
      })
      .addCase(getCreditUsers.fulfilled, (state, action) => {
        state.creditUsers = action.payload?.data;
        state.creditLoading = false;
      })
      .addCase(getUsersCart.pending, (state) => {
        state.usersCartLoading = true;
      })
      .addCase(getUsersCart.fulfilled, (state, action) => {
        state.usersCart = action.payload;
        state.usersCartLoading = false;
      })
      .addCase(getSKU.pending, (state) => {
        state.skuLoading = true;
      })
      .addCase(getSKU.fulfilled, (state, action) => {
        state.sku = action.payload?.product;
        state.skuLoading = false;
      })
      .addCase(getBrands.pending, (state) => {
        state.brandLoading = true;
      })
      .addCase(getBrands.fulfilled, (state, action) => {
        state.brands = action.payload;
        state.brandLoading = false;
      })
      .addCase(getProductDetails.pending, (state) => {
        state.productDetailLoading = true;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.productDetail = action.payload;
        state.productDetailLoading = false;
      })
      .addCase(updateCreditStatus.pending, (state) => {
        state.creditStatusLoading = true;
      })
      .addCase(updateCreditStatus.fulfilled, (state) => {
        state.creditStatusLoading = false;
      })
      .addCase(activateUserCredit.pending, (state) => {
        state.creditStatusLoading = true;
      })
      .addCase(activateUserCredit.fulfilled, (state) => {
        state.creditStatusLoading = false;
      })
      .addCase(addCouponCode.pending, (state) => {
        state.addCouponLoading = true;
      })
      .addCase(addCouponCode.fulfilled, (state) => {
        state.addCouponLoading = false;
      })
      .addCase(checkPhoneNumberAsync.pending, (state) => {
        state.checkPhoneNumberLoading = true;
      })
      .addCase(checkPhoneNumberAsync.fulfilled, (state) => {
        state.checkPhoneNumberLoading = false;
      })
      .addCase(registerPhoneNumberAsync.pending, (state) => {
        state.registerPhoneNumberLoading = true;
      })
      .addCase(registerPhoneNumberAsync.fulfilled, (state) => {
        state.registerPhoneNumberLoading = false;
      })
      .addCase(fetchWalletDetailAsync.pending, (state) => {
        state.walletDetailLoading = true;
      })
      .addCase(fetchWalletDetailAsync.fulfilled, (state,action) => {
        state.walletDetailLoading = false;
        state.walletDetail=action.payload;
      });
  },
});

export default adminSlice.reducer;
